import {
  ClearIcon,
  CreateStoryIllustrationIcon,
  ImageIcon,
  VideoPlayIcon,
} from '@weblite/icons'
import { getFileFromUser } from '@weblite/file'
import { Button, IconButton, Typography, styled } from '@mui/material'
import { t } from '$i18n'
import { CreateStoryHeader } from './header'

interface Props {
  onClose?: () => void
  onChooseFile: (file: File) => void
}

export function CreateStoryChooseFile({ onClose, onChooseFile }: Props) {
  return (
    <Root>
      <CreateStoryHeader>
        <IconButton
          size="medium"
          onClick={onClose}
          data-test-id="create-story-choose-file-close-button"
        >
          <ClearIcon
            sx={{ color: 'neutral000', width: '24px', height: '24px' }}
          />
        </IconButton>
        <Typography
          variant="subtitle1"
          color="neutral000"
          data-test-id="create-story-choose-file-header-title"
        >
          {t('story.addStory')}
        </Typography>
      </CreateStoryHeader>
      <Content>
        <CreateStoryIllustrationIcon sx={{ width: '64px', height: '48px' }} />
        <Typography variant="subtitle2" color="neutral300">
          {t('story.createStoryModal.chooseOneOfBelowOptions')}
        </Typography>
      </Content>
      <ActionButtons>
        <ActionButton
          onClick={() =>
            getFileFromUser(
              'image/*',
              file => {
                onChooseFile(Array.isArray(file) ? file[0] : file)
              },
              false,
            )
          }
        >
          <ImageIcon sx={{ color: 'inherit', width: '24px', height: '24px' }} />
          <Typography variant="subtitle1" color="inherit">
            {t('story.createStoryModal.storyTypes.image')}
          </Typography>
        </ActionButton>
        <ActionButton
          onClick={() =>
            getFileFromUser(
              'video/*',
              file => {
                onChooseFile(Array.isArray(file) ? file[0] : file)
              },
              false,
            )
          }
        >
          <VideoPlayIcon
            sx={{ color: 'inherit', width: '24px', height: '24px' }}
          />
          <Typography variant="subtitle1" color="inherit">
            {t('story.createStoryModal.storyTypes.video')}
          </Typography>
        </ActionButton>
      </ActionButtons>
    </Root>
  )
}

const Root = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.palette.neutral1000};
`

const Content = styled('div')`
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
`

const ActionButtons = styled('div')`
  padding: 24px;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
`

const ActionButton = styled(Button)`
  background: ${({ theme }) => theme.palette.storyGradientH};
  width: calc(50% - 12px);
  height: 80px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.palette.neutral000};
  &:hover,
  &:active {
    background: ${({ theme }) => theme.palette.storyGradientH};
  }
`
